import axios from 'axios';
import {
  GetUserByTokenPaymentMethodLinkReturn,
  LinkMethodPayment,
} from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import cms from './cms';

export async function getPaymentMethodLink(
  authId: string
): Promise<LinkMethodPayment> {
  try {
    if (!authId) throw new Error('authId is required');
    const response = await cms.post('/v2/payment-method/create-link', {
      customer: authId,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getUserByTokenPaymentMethodLink(
  token: string
): Promise<GetUserByTokenPaymentMethodLinkReturn> {
  try {
    const response = await cms.get(`/v2/payment-method/retrieve-link/${token}`);
    return response.data;
  } catch (error: unknown) {
    console.error(error);
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.error.message || 'Error desconocido'
      );
    }

    throw new Error('Error al obtener el link');
  }
}
